<template>
  <div class="page_wrapper container-fluid news_area">
    <div class="row page_header news_header">
      <news-header />
    </div>
    <div class="row news_index_content">
      <news-index-content :news-feed="news" />
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import NewsHeader from '~components/pages/news/NewsHeader'
import NewsIndexContent from '~components/pages/news/NewsContent'
import '~style/pages/news.scss'
export default {
  name: 'NewsIndex',
  routerName: 'News',
  components: {
    NewsHeader,
    NewsIndexContent
  },
  data() {
    return {
      news: []
    }
  },
  async created() {
  },
  methods: {
    ...mapActions('pages/news', [
      'getNewsAll'
    ])
  }
}
</script>
